const MAX_DIMENSION = 1600;
const QUALITY = 0.8;

// Сжимает фото на клиенте перед отправкой (ресайз до MAX_DIMENSION + JPEG).
// Иначе крупные снимки с камеры телефона упираются в таймаут мобильного канала
// и в лимиты памяти браузера при сборке multipart. При любой неудаче (не
// изображение, ошибка декодирования, размер не уменьшился) возвращает оригинал.
export const compressImage = (file: File): Promise<File> =>
	new Promise((resolve) => {
		if (!file.type.startsWith('image/')) {
			resolve(file);
			return;
		}

		const objectUrl = URL.createObjectURL(file);
		const image = new Image();

		image.onload = () => {
			URL.revokeObjectURL(objectUrl);

			const scale = Math.min(1, MAX_DIMENSION / Math.max(image.width, image.height));
			const width = Math.round(image.width * scale);
			const height = Math.round(image.height * scale);

			const canvas = document.createElement('canvas');
			canvas.width = width;
			canvas.height = height;

			const ctx = canvas.getContext('2d');
			if (!ctx) {
				resolve(file);
				return;
			}

			ctx.drawImage(image, 0, 0, width, height);

			canvas.toBlob(
				(blob) => {
					if (!blob || blob.size >= file.size) {
						resolve(file);
						return;
					}

					const name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
					resolve(
						new File([blob], name, {
							type: 'image/jpeg',
							lastModified: file.lastModified,
						}),
					);
				},
				'image/jpeg',
				QUALITY,
			);
		};

		image.onerror = () => {
			URL.revokeObjectURL(objectUrl);
			resolve(file);
		};

		image.src = objectUrl;
	});
